module.exports = __webpack_public_path__ + "img/audios.65505cc8.svg";